import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { verifyMFA, resendMobileMFACode } from '../../store/routines';
import { MFA_TYPES } from '../../common/constants/UserManagementConstants';
import { cognitoErrorMessageFormatter } from '../../common/util/authUtils';

function TwoFactorAuthViaAppInputForm() {
  const dispatch = useDispatch();
  const history = useHistory();

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isError);
  const challengeUser = useSelector((state) => state.auth.challengeUser);
  const username = useSelector((state) => state.auth.username);
  const temporaryPassword = useSelector(
    (state) => state.auth.temporaryPassword
  );
  const { challengeName, challengeParam } = challengeUser;
  const isResendMFALoading = useSelector(
    (state) => state.auth.isResendMFALoading
  );
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(false);
  let timer = null;

  if (!challengeName) {
    history.replace('/login');
  }

  const [inputCode, setInputCode] = useState(null);

  const onVerifyClick = () => {
    dispatch(verifyMFA({ verificationCode: inputCode, challengeUser }));
  };

  const handleCodeInput = (input) => {
    const { value } = input.target;
    const formattedInput = value.replace(/\D/g, '');
    setInputCode(formattedInput);
  };

  const resendCodeClick = () => {
    setIsResendButtonDisabled(true);
    timer = setTimeout(() => setIsResendButtonDisabled(false), 30000);
    dispatch(resendMobileMFACode({ username, password: temporaryPassword }));
  };

  useEffect(() => {
    // clear Timeout
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="login-input-wrapper twofaform">
        <div className="title smaller">Verify your identity</div>
        <div className="subtitle">
          {`Please enter the 6-digit code ${
            challengeName === MFA_TYPES.SMS_MFA
              ? `sent to the phone number ending in ${challengeParam.CODE_DELIVERY_DESTINATION}`
              : 'generated by your authenticator app'
          }`}
        </div>
        <div className="login-form">
          {isError && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />
              {cognitoErrorMessageFormatter(errorMessage)}
            </div>
          )}
          <Input
            value={inputCode}
            onChange={handleCodeInput}
            className="login-field twofa"
            maxLength="6"
          />
          {/* <Button
            tabIndex={0}
            role="button"
            className="btn link-button-text-only purple underlined no-side-padding"
          >
            Lost access to your authenticator?
          </Button> */}
          <Button
            className="login-form-button loginbtn"
            disabled={!inputCode || inputCode.length !== 6}
            onClick={onVerifyClick}
          >
            Verify
          </Button>
        </div>
        {/* <div className="didnt-recieve-code-link">Didn’t receive your code?</div> */}
        {challengeName === MFA_TYPES.SMS_MFA && (
          <div className="request-new-code">
            Please allow <strong>30 seconds</strong> for the message to arrive
            before requesting another code.{' '}
            <Button
              className="btn link-button-text-only purple inline no-side-padding"
              onClick={resendCodeClick}
              disabled={isResendButtonDisabled}
              loading={isResendMFALoading}
            >
              Request another code
            </Button>
          </div>
        )}
        <div>
          If you do not have access to your device contact{' '}
          <a
            tabIndex={0}
            role="button"
            href="mailto:support@velaris.io?subject=Lost Access to device via 2FA"
          >
            support@velaris.io
          </a>{' '}
          to recover your account.
        </div>
      </div>
      <div className="floating-login-footer">
        {/* <div>
          Can’t find your code? Check your spam folder!{' '}
          <a
            tabIndex={0}
            role="button"
            onClick={() => history.push(routes.loginManagement.forgotPassword)}
            className="request-new-pw"
          >
            Resend Code
          </a>
        </div> */}
        {/* <div>
          Remember your password?{' '}
          <a
            tabIndex={0}
            role="button"
            onClick={() => history.push(routes.loginManagement.login)}
            className="request-new-pw"
          >
            Back to Log in
          </a>
        </div> */}
      </div>
    </>
  );
}

export default TwoFactorAuthViaAppInputForm;
